import React from 'react'

export default function DiscoverArrow() {
    return (
        <>
            <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-1f4b88b5=""><path d="M6.20839 7.95806L5.32561 7.13206L7.78582 4.59806L-3.98998e-07 4.59806L-2.93741e-07 3.39406L7.78582 3.39406L5.32561 0.860058L6.20839 0.0340582L10 3.99606L6.20839 7.95806Z" fill="#222222" data-v-1f4b88b5=""></path></svg>
        </>
    )
}